import { render, staticRenderFns } from "./ReportRiskArea.vue?vue&type=template&id=507d8fa1"
import script from "./ReportRiskArea.vue?vue&type=script&lang=js"
export * from "./ReportRiskArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports